import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import ReusableTable from '../../other/ReuseableTable'
import Loader from '../../../pages/pages/loader'
import EditCreateServices from './EditCreateServices'
import { toast } from 'react-toastify'
import { can } from '../../../helpers/auth'
import {
  useDeleteCustomerServiceMutation,
  useGetCustomerServicesQuery,
  useUpdateCustomerServiceMutation
} from '../../../redux/apis/customersManagement/services/cMcustomerServicesApiSlice'

const CustomersServices = ({ open, setOpen, record }) => {
  const { data, isLoading } = useGetCustomerServicesQuery({
    customer: record?.id,
    expand: ['last_updated_by', 'service'].join(','),
    page: '*'
  })
  const [deleteService, { isLoading: deleteIsLoading, isSuccess, error }] =
    useDeleteCustomerServiceMutation()
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateCustomerServiceMutation()
  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'SERVICE',
      dataIndex: 'service',
      key: 'service.service_name',
      search: true,
      render: text => <div>{text?.service_name}</div>
    },
    {
      title: 'Is Active',
      dataIndex: 'is_active',
      key: 'is_active',
      search: true,
      render: text => <div>{text ? 'Active' : 'In Active'}</div>
    },

    {
      title: 'SERVICE FREQUENCY',
      dataIndex: 'service_frequency',
      key: 'service_frequency',
      search: true
    },
    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at',
      search: true
    },
    {
      title: 'Updated AT',
      dataIndex: 'updated_at',
      key: 'updated_at',
      search: true
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <div className=''>
          <p>
            {text.first_name} {text.last_name}
          </p>
        </div>
      )
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, service) => (
        <div className='flex gap-2'>
          {can('put_customer_services') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(service)}
            >
              Edit
            </button>
          )}
          {can('put_customer_services') && (
            service.is_active ? (
              <button
                className='btn btn-danger'
                onClick={() => deleteService(service?.id)}
              >
                Deactivate
              </button>
            ) : (
              <button
                className='btn btn-theme w-full'
                onClick={() =>
                  updateService({
                    id: service?.id,
                    body: {
                      is_active: true,
                      customer: service?.customer,
                      service: service?.service?.id,
                      service_frequency: service?.service_frequency
                    }
                  })
                }
              >
                Active
              </button>
            )
          )}
        </div>
      )
    }
  ]

  const handleEdit = service => {
    setHolder(service)
    setEdit(true)
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error, errorUpdate])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Service deleted successfully!')
    }
  }, [isSuccess])

  useEffect(() => {
    if (SuccessUpdate) {
      toast.success('Service updated successfully!')
    }
  }, [SuccessUpdate])

  return (
    <Modal
      className='custom-modal'
      open={open}
      title={`${record?.customer_name} Services`}
      onCancel={() => setOpen(false)}
      width={'60%'}
      footer={false}
    >
      <div className='w-full flex flex-col'>
        <Loader isLoading={isLoading || deleteIsLoading} />
        {create ? (
          <EditCreateServices
            state={'create'}
            open={create}
            setOpen={setCreate}
            record={null}
            customerId={record?.id}
          />
        ) : null}
        {edit ? (
          <EditCreateServices
            state={'edit'}
            open={edit}
            setOpen={setEdit}
            record={holder}
          />
        ) : null}
        {can('post_customer_services') && (
          <button
            className='btn btn-outline-theme ml-auto'
            onClick={() => setCreate(true)}
          >
            Create New Service
          </button>
        )}
        <br />
        <div className='row'>
          <ReusableTable
            columns={columns}
            data={data?.data?.results}
            color='black'
          />
        </div>
      </div>
    </Modal>
  )
}

export default CustomersServices
